import api from './api';

export interface ComprasRpt01Row {
  nroIdformulario: number;
  fecha: string;
  nroItem: number;
  iteCodigoArticulo: string;
  iteDescripcion?: string | null;
  iteCantidad?: number | null;
  precioUnitario?: number | null;
  precioUnitarioFinal?: number | null;
  subtotal?: number | null;
  subtotalFinal?: number | null;
  nroFormulario?: number | null;
  nroTipoFormulario?: string | null;
  letra?: string | null;
  nroSuc?: number | null;
  nroComprobante?: number | null;
  fechaEmision?: string | null;
  fechaVencim?: string | null;
  nroCliente?: number | null;
  nombre?: string | null;
  proNombre?: string | null;
  cuit?: string | null;
  proCuit?: string | null;
  tipoIva?: string | null;
  forDescripcion?: string | null;
  tipDescripcion?: string | null;
  tipArea?: string | null;
  nroUbicacion?: number | null;
  entradaSalida?: string | null;
  importeTotal?: number | null;
  importeSinIva?: number | null;
  forSubtotal?: number | null;
  forDescuento?: number | null;
  exento?: number | null;
  ivainscripto?: number | null;
  ivanoInscripto?: number | null;
  ivaotro?: number | null;
  percepciones?: number | null;
  formaDePago?: string | null;
  codigoArticulo?: string | null;
  descripcion?: string | null;
  idUnidadMedida?: string | null;
  nombreRamo?: string | null;
  nombreLinea?: string | null;
  nombreClase?: string | null;
  venNombreVendedor?: string | null;
  forNroVendedor?: number | null;
  usuario?: string | null;
  liquidado?: string | null;
  facturado?: string | null;
  nroRemito?: string | null;
  iteCosto?: number | null;
  descuento?: number | null;
  bonificacion?: number | null;
  ciuNombreCiudad?: string | null;
  pciaNombreProvincia?: string | null;
  rutNombreRuta?: string | null;
  iteCentroCosto?: number | null;
  codBarra?: string | null;
  tipoArticulo?: string | null;
  asentado?: string | null;
  tasa1?: number | null;
  tasa2?: number | null;
}

export interface ComprasRpt01Response {
  data: ComprasRpt01Row[];
  totalMatched: number;
  truncated: boolean;
}

export interface GetRptCompras01Params {
  fechaDesde: string;
  fechaHasta: string;
  nroProveedor?: number;
  codigoArticulo?: string;
  nroTipoFormulario?: string;
  nroSuc?: number;
  maxRows?: number;
}

const comprasInformesService = {
  getRptCompras01: async (params: GetRptCompras01Params): Promise<ComprasRpt01Response> => {
    const query = new URLSearchParams();
    query.append('fechaDesde', params.fechaDesde);
    query.append('fechaHasta', params.fechaHasta);
    if (params.nroProveedor != null && params.nroProveedor !== undefined) {
      query.append('nroProveedor', String(params.nroProveedor));
    }
    if (params.codigoArticulo?.trim()) {
      query.append('codigoArticulo', params.codigoArticulo.trim());
    }
    if (params.nroTipoFormulario?.trim()) {
      query.append('nroTipoFormulario', params.nroTipoFormulario.trim());
    }
    if (params.nroSuc != null && params.nroSuc !== undefined) {
      query.append('nroSuc', String(params.nroSuc));
    }
    if (params.maxRows != null) {
      query.append('maxRows', String(params.maxRows));
    }

    const response = await api.get<ComprasRpt01Response>(
      `/api/ComprasInformes/rpt-compras-01?${query.toString()}`
    );
    return response.data;
  },
};

export default comprasInformesService;
